// extracted by mini-css-extract-plugin
module.exports = {"content":"errorForm_content__reOeO","wrapper":"errorForm_wrapper__RsOHw","info":"errorForm_info__iBguJ","info__title":"errorForm_info__title__ldlBq"};